// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedSlitLampRight_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.8301 8C21.8301 12.4183 18.2484 16 13.8301 16C9.4118 16 5.83008 12.4183 5.83008 8C5.83008 3.58172 9.4118 0 13.8301 0C18.2484 0 21.8301 3.58172 21.8301 8ZM11.8301 2.34141C9.49969 3.16508 7.83008 5.38756 7.83008 8C7.83008 10.6124 9.49969 12.8349 11.8301 13.6586V2.34141ZM19.8301 8C19.8301 10.6124 18.1605 12.8349 15.8301 13.6586V2.34141C18.1605 3.16508 19.8301 5.38756 19.8301 8Z" class="svg-bg"/>
  <path d="M5.46 12.498 2 18.4909 2.15085 18.5H4.30417L6.72502 14.307C6.23678 13.7573 5.81135 13.1506 5.46 12.498ZM13.8301 17.5006C13.9275 17.5006 14.0245 17.4991 14.1212 17.4962L11.2323 22.5H9.07895L8.9281 22.4909 11.9202 17.3086C12.5371 17.4345 13.1759 17.5006 13.8301 17.5006ZM4.01551 23H6.32491L9.97133 16.6842C9.35714 16.4109 8.77732 16.0743 8.24013 15.6827L4.01551 23Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedSlitLampRight is a generated icon component.
 */
let IconMedSlitLampRight = IconMedSlitLampRight_1 = class IconMedSlitLampRight extends IconBaseElement {
    render() {
        return html `${IconMedSlitLampRight_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedSlitLampRight.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedSlitLampRight = IconMedSlitLampRight_1 = __decorate([
    customElement('zui-icon-med-slit-lamp-right')
], IconMedSlitLampRight);
export { IconMedSlitLampRight };
